import React from 'react'
import { Button } from '@mui/material'
import DateOutlinedInput from '../../input/DateOutlinedInput'
import CustomOutlinedInput from '../../input/CustomOutlinedInput'
import SearchIcon from '@mui/icons-material/Search'
import LayersClearIcon from '@mui/icons-material/LayersClear'

const BidSearchForm = ({ 
        targetDateId, 
        targetDateValue, 
        targetDateOnChange,
        keywordId, 
        keywordValue, 
        keywordOnChange, 
        handleSearch, 
        handleSearchClear, 
        display_search = true
    }) => {
    return (
        <div style={{display:'flex'}}>
            <div>
                <DateOutlinedInput 
                    id       = { targetDateId } 
                    label    = "登録日" 
                    value    = { targetDateValue } 
                    onChange = { targetDateOnChange } 
                />
            </div>
            {
                display_search ?
                <>
                <div style={{marginLeft:'10px'}}>
                    <CustomOutlinedInput
                        type     = "text" 
                        id       = { keywordId } 
                        value    = { keywordValue } 
                        label    = "荷主・品名を入力して検索" 
                        width    = "310px" 
                        onChange = { keywordOnChange } 
                    />
                </div>
                </>
                :
                <></>
            }
            <div style={{marginLeft:'10px'}}>
                <Button
                    color     = "secondary"
                    style     = {{color:'#fff'}}
                    size      = "midium"
                    variant   = "contained"
                    onClick   = { handleSearch }
                    startIcon = {<SearchIcon />}
                    sx        = {{paddingLeft:'30px'}}
                >
                </Button>
            </div>
            <div style={{marginLeft:'10px'}}>
                <Button
                    color     = "secondary"
                    style     = {{color:'#fff'}}
                    size      = "midium"
                    variant   = "contained"
                    onClick   = { handleSearchClear }
                    startIcon = {<LayersClearIcon />}
                    sx        = {{paddingLeft:'30px'}}
                >
                </Button>
            </div>
        </div>
    );
}

export default BidSearchForm